import React from "react";
import "../pages/About.css";

const About = () => {
  return (
    <div className="about-container">
      {/* Profile Image */}
      <div className="about-header">
        <img
          src={`${process.env.PUBLIC_URL}/imgs/c.jpg`}
          alt="Profile"
          className="about-profile-image"
        />
      </div>

      {/* Title */}
      <h1 className="about-title">Σχετικα με Εμενα</h1>

      <>
        <p className="about-text fade-in">
          Γεννήθηκα στις 3 Ιανουαρίου 2002 στη Λάρισα, και το χιόνι εκείνη τη μέρα είχε μια ιδιαίτερη παρουσία, σαν να ήθελε να καλωσορίσει το νέο μέλος της πόλης.
        </p>
        <p className="about-text fade-in delay-1">
          Η μουσική είναι μεγάλη μου αγάπη. Αν με ρωτήσεις ποιος είναι ο αγαπημένος μου καλλιτέχνης, δεν θα σου πω ποτέ κάτι σταθερό. Η μουσική είναι κάτι που αλλάζει με τη μέρα, με τη διάθεση, και πιστεύω ότι έτσι πρέπει να είναι. Θα ακούς αυτό που σε εμπνέει και σε βοηθάει να συνεχίζεις κάθε φορά.
        </p>
        <p className="about-text fade-in delay-2">
          Από μικρός ασχολούμαι με την κιθάρα και το μπουζούκι – για μένα η μουσική ήταν πάντα μια διέξοδος, ένας τρόπος να ξεφεύγω και να εκφράζομαι πέρα από τις λέξεις.
        </p>
        <p className="about-text fade-in delay-3">
          Η πορεία μου μέχρι τώρα δεν ήταν πάντα εύκολη, αλλά πάντα υπήρχε κάτι που με παρακινούσε να προχωρήσω. Αποφοίτησα με Άριστα από το ΓΕΛ Φαλάνης και συνέχισα με σπουδές στο Πανεπιστήμιο Πειραιώς στο τμήμα Ψηφιακών Συστημάτων, απ’ όπου πήρα το πτυχίο μου με 7.5.
        </p>
        <p className="about-text fade-in delay-4">
          Όταν ήμουν 19, αποφάσισα πως ήθελα να μπω νωρίς στην αγορά εργασίας για να ανεξαρτητοποιηθώ από την οικογένειά μου. Το κατάφερα και νιώθω περήφανος γι' αυτό.
        </p>
        <p className="about-text fade-in">
          Η επαγγελματική μου πορεία ξεκίνησε με τηλεφωνική εξυπηρέτηση, μετά ασχολήθηκα με το chat support, και αργότερα μπήκα στον κόσμο του προγραμματισμού και των δικτυακών υποδομών. Εργασίες που με πήγαν σε όμορφα μέρη, από την Ίο μέχρι τη Ρώμη, και μου γνώρισαν εκπληκτικούς ανθρώπους με μοναδικές ιστορίες.
        </p>
        <p className="about-text fade-in delay-1">
          Με ενδιαφέρει να κατανοώ πώς λειτουργεί ο κόσμος γύρω μου. Μου αρέσει να εξερευνώ και να μαθαίνω.
        </p>
        <p className="about-text fade-in delay-2">
          Μετά ήρθε και ο στρατός. Πέρασα 3 μήνες στην Αυλώνα, και, αν και δεν ήταν οι καλύτερες μέρες, με βοήθησε - να προσπαθήσω τουλάχιστον- να μειώσω την γκρίνια μου. Να αντιμετωπίζω καταστάσεις περίεργες και από το τίποτα να κρατάω τα θετικά και να προχωράω. Γνώρισα υπέροχους ανθρώπους , ο καθένας με τη δική του ιστορία. Πανέμορφο.
        </p>
        <p className="about-text fade-in delay-3">
          Από την εμπειρία του στρατού κρατάω τις γνωριμίες, που από ξένοι έγιναν οικογένεια και έμαθα ποιοι άνθρωποι ήταν πραγματικά δίπλα μου.
        </p>
        <p className="about-text fade-in">
          Από το Νοέμβριο του 2024 που μπήκα στο στρατό , ξεκίνησα και την δημιουργία αυτής της σελίδας. Σκοπός ήταν να έχω κάπου συγκεντρωμένες τις ιδέες μου καθώς και να χτίσω κάτι από το 0.
        </p>
        <p className="about-text fade-in delay-1">
          Αυτή η σελίδα είναι το μέρος όπου αποθηκεύω τα άρθρα μου, τις σκέψεις μου. Γράφω συχνά για προσωπική ευχαρίστηση. Γράφω καθώς νιώθω πως είναι ένας από τους τρόπους για να δώσω στις ιδέες μου ένα «σώμα», αλλά κυρίως γράφω γιατί μου αρέσει να εκφράζομαι.
        </p>
        <p className="about-text fade-in delay-2">
          Πρωτίστως βέβαια, μου αρέσει να παρατηρώ. Παρατηρώ συμπεριφορές ανθρώπων, τα λόγια τους, τα βλέμματα τους.
        </p>
        <p className="about-text fade-in delay-3">
          Πιστεύω πως υπάρχουν άνθρωποι που απλώς ζουν και άνθρωποι που παρατηρούν και κατανοούν τον κόσμο γύρω τους. Εγώ επιλέγω να είμαι αυτός που παρατηρεί και ανακαλύπτει τις ιστορίες πίσω από κάθε στιγμή. Προσπαθώ τουλάχιστον...
        </p>
        <p className="about-text fade-in delay-4">
          Η ζωή είναι μικρή, το έχω καταλάβει αυτό. Όλα έχουν ημερομηνία λήξης. Ακόμα και η ύπαρξή μας. Το τώρα.
        </p>
        <p className="about-text fade-in delay-1">
          Η ζωή είναι πολύ σύντομη για να ζούμε τα όνειρα κάποιου άλλου. Πρέπει να είμαστε αληθινοί στον εαυτό μας, να ακολουθούμε τη δική μας πορεία, να κάνουμε το αδύνατο δυνατό, αν πιστεύουμε πραγματικά σε αυτό.
        </p>
        <p className="about-text fade-in delay-2">
          Η κάθε μέρα είναι μια νέα ευκαιρία να ξαναρχίσουμε, να δημιουργήσουμε τις δικές μας στιγμές, να γράψουμε τη δική μας ιστορία. Στο τέλος, αυτό που μένει είναι οι στιγμές που ζήσαμε και οι άνθρωποι που αγαπήσαμε.
        </p>
        <p className="about-text fade-in delay-3">
          Να είμαστε παρόντες, να ζούμε με αλήθεια και πάθος, γιατί η ζωή, όσο μικρή κι αν είναι, μπορεί να μεγαλώσει μέσα από τις στιγμές που δημιουργούμε. Ας τις κάνουμε να αξίζουν.
        </p>
        <p className="about-text fade-in delay-4">
          Ζω, επίσης, για να καταλαβαίνω, να νιώθω, και να αφηγούμαι. Κάθε μέρα είναι ένα καινούριο κεφάλαιο, και κάθε συνάντηση μια μικρή ιστορία. Συλλέγω στιγμές, λέξεις και σκέψεις που μένουν στον αέρα και τις μετατρέπω σε ιστορίες. Για μένα, η ζωή δεν είναι απλώς να υπάρχω. Είναι να ανακαλύπτω και να μοιράζομαι όλα όσα μπορεί να κρύβει ο κόσμος.
        </p>
        <p className="about-text fade-in delay-1">
          Να βλέπω πέρα από τα προφανή, να ανακαλύπτω τις ιστορίες που κρύβονται στις σκιές της καθημερινότητας. Και όσο υπάρχω, θα συνεχίσω να παρατηρώ. Γιατί κάθε άνθρωπος, κάθε βλέμμα, κάθε τυχαία στιγμή έχει κάτι να πει – και εγώ είμαι εδώ για να το ακούσω.
        </p>
        <p className="about-text fade-in delay-1">
          Καλωσήρθατε στην δική μου ιστορία.
        </p>
        <p className="about-text fade-in delay-2">
          "Think big, Work hard, Have fun, Make history"
        </p>
</>


      <div className="about-header">
        <img
          src={`${process.env.PUBLIC_URL}/imgs/photo.jpg`}
          alt="Profile"
          className="about-profile-image"
        />
      </div>
    </div>
  );
};

export default About;
